import React from 'react';
import { Modal, TextContainer } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

interface RollbackConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUninstall?: () => void;
  onRejectAndUninstall?: () => void;
  title?: React.ReactNode;
  content?: React.ReactNode;
  primaryActionText?: React.ReactNode;
  secondaryActionText?: React.ReactNode;
}

const RollbackConfirmationModal: React.FC<RollbackConfirmationModalProps> = ({
  isOpen,
  onClose,
  onUninstall,
  onRejectAndUninstall,
  title = (
    <>
      <FormattedMessage id="patch.rollback.title" />
    </>
  ),
  content = <FormattedMessage id="patch.rollback.reject.confirmation" />,
  primaryActionText = <FormattedMessage id="patch.rollback.only" />,
  secondaryActionText = <FormattedMessage id="patch.rollback.andReject" />
}) => {
  return (
    <Modal
      dialogClassName="transparent-modal-bg"
      open={isOpen}
      onClose={onClose}
      variant="confirmation"
      title={title}
      primaryAction={{
        content: primaryActionText,
        onAction: () => {
          onUninstall?.();
          onClose();
        }
      }}
      showCloseButtonForConfirmation
      iconSize="xl"
      secondaryActions={[
        {
          content: secondaryActionText,
          onAction: () => {
            onClose();
            onRejectAndUninstall?.();
          }
        }
      ]}
    >
      <TextContainer>{content}</TextContainer>
    </Modal>
  );
};

export default RollbackConfirmationModal;
